import ShareableLinkAccessBeforeNavigateToDr from './ShareableLinkAccessBeforeNavigateToDr.component';

export default ShareableLinkAccessBeforeNavigateToDr;
